/**
 * Handle the main/base template display and functionality
 */
const $inject = [
  "$state",
  "$rootScope",
  "$scope",
  "MessageService",
  "RequestInterceptorService",
];

class AppController {
  constructor(
    $state,
    $rootScope,
    $scope,
    MessageService,
    RequestInterceptorService
  ) {
    let self = this;
    this._state = $state;
    this.stateName = $state.current.name;

    this.debug = false;

    this.isAccount = this.isState("app.login") || this.isState("app.registration") || this.isState("app.verify") || this.isState("app.pin") || this.isState("app.cancelToken") || this.isState("app.updateToken") || this.isState("app.tandc") || this.isState("app.privacy");

    $scope.show_toast = function ($message, $class) {
      self.globalMessage = {
        error: true,
        class: $class,
        errorMsg: $message,
        hideGlobalMessage: $scope.hide_toast,
      };
    };

    $scope.hide_toast = function () {
      self.globalMessage.error = false;
    };

    $rootScope.$on("display-toast", function (event, ...parameters) {
      $scope.show_toast.apply(self, parameters);
    });

    $rootScope.$on("remove-toast", function (event, ...parameters) {
      $scope.hide_toast.apply(self, parameters);
    });

    //For unexpected system/global messages
    this.globalMessage = RequestInterceptorService.getGlobalMessage();
    $rootScope.$on(
      "$stateChangeStart",
      function (event, toState, toParams, fromState, fromParams) {
        MessageService.clearAll();
      }
    );
  }

  hideGlobalMessage() {
    this.globalMessage.error = false;
  }

  isState(name) {
    return this._state.includes(name);
  }

  /**
   * Toggle Overlay menu
   */
  toggleMenu(event) {
    var $hamburger = $(event.delegateTarget);
    var $overlay = $("div.overlay");

    if ($hamburger.hasClass("active")) {
      $overlay.removeClass("open");
      $hamburger.removeClass("active");
    }
    else {
      $overlay.addClass("open");
      $hamburger.addClass("active");
    }
  }
}

AppController.$inject = $inject;

export default AppController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/controllers/app.controller.js
 **/